import {DataFetcher, useGrpcRequest} from '@aboutyou/data-fetcher';
import {CategoryNavigationService_GetTreeNavigationLazy} from '@aboutyou/grpc-clients/tadarida/aysa_api/services/category_page/v1/navigation/service.grpc.lazy';
import {useTranslation} from '@aboutyou/i18n';
import {originClick} from '@aboutyou/legacy-tracking-sdk';
import {useFullSession} from '@aboutyou/user';
import React from 'react';
import {
  NavigationTree,
  NavigationTreeProps,
} from '../../../features/NavigationTree/NavigationTree';
import {NavigationTreeLoading} from '../../../features/NavigationTree/NavigationTreeLoading';
import {useAppliedPotentialFilters} from '../../../features/ProductStream/utils';
import {useReductionsStateRequestParameter} from '../../../features/ReductionsState/useReductionsStateRequestParameter';
import {FIRST_PRODUCT_ID_PARAM} from '../../../features/firstProductId/useFirstProductIds';
import {useTargetGroupIdentifier} from '../../../shared-deprecated/useTargetGroupIdentifier';
import {
  useAppliedQuickFilter,
  useCategoryCacheKeyTransformer,
  useCategoryIdentifier,
} from '../utils';

interface CategoryTreeProps {
  category?: number;
  className?: string;
}

export const CategoryNavigationTree: React.FC<CategoryTreeProps> = ({
  category,
  className,
}) => {
  const {t} = useTranslation();

  return (
    <DataFetcher
      request={useCategoryTree(category)}
      Error={() => null}
      Loading={NavigationTreeLoading}
      View={NavigationTree}
      viewProps={{
        className,
        trackOriginKey: 'category_tree_side' as originClick,
        testId: 'categoryNavigationTree',
        'aria-label': t('Categories'),
        excludeUrlParams: [
          FIRST_PRODUCT_ID_PARAM,
        ] as NavigationTreeProps['excludeUrlParams'],
      }}
    />
  );
};

export const useCategoryTree = (category?: number) => {
  const categoryIdentifier = useCategoryIdentifier();
  const appliedFilters = useAppliedPotentialFilters();
  const appliedQuickFilter = useAppliedQuickFilter();
  const categoryCacheKeyTransformer = useCategoryCacheKeyTransformer();
  const targetGroupIdentifier = useTargetGroupIdentifier();
  const fullSession = useFullSession();

  return useGrpcRequest(
    CategoryNavigationService_GetTreeNavigationLazy,
    {
      category: {
        identifier: category ? {$case: 'id', id: category} : categoryIdentifier,
      },
      targetGroup: targetGroupIdentifier,
      appliedFilters: {
        filters: appliedFilters,
        quickFilter: appliedQuickFilter,
      },
      reductionsState: useReductionsStateRequestParameter(),
      session: fullSession,
    },
    {keepPreviousData: true, transformCacheKey: categoryCacheKeyTransformer},
  );
};
